import React from 'react';
import { getApiConfig, isLocalDevelopment } from '../../utils/config';
import './ConfigDebug.css';

const ConfigDebug: React.FC = () => {
  const config = getApiConfig();
  const currentPath = window.location.pathname;
  
  // Only show in local development
  if (!isLocalDevelopment()) {
    return null;
  }

  return (
    <div className="config-debug">
      <div className="config-debug-header">
        <span>🔧 Debug Info</span>
      </div>
      <div className="config-debug-content">
        <div><strong>Environment:</strong> {config.environment}</div>
        <div><strong>API Base URL:</strong> {config.baseUrl}</div>
        <div><strong>Current Domain:</strong> {window.location.hostname}</div>
        <div><strong>Current Port:</strong> {window.location.port || 'default'}</div>
        {currentPath === '/' && (
          <div style={{ marginTop: '0.5rem', paddingTop: '0.5rem', borderTop: '1px solid #333' }}>
            <strong style={{ color: '#00ff00' }}>Test Route:</strong><br/>
            <span style={{ fontSize: '0.7rem' }}>/01234567890123456789012345678901</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ConfigDebug;